import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import './SaveTheDate.css';
import icon from '../Assets/Icons/saveTheDate.png'
import fdm from '../Assets/Icons/favicon.png'

const SaveTheDate = () => {
  const { friendlyURL } = useParams();

  const [weddingDate, setWeddingDate] = useState("");
  const [clientName, setClientName] = useState("");
  const [spouse, setSpouse] = useState("");
  const [loading, setLoading] = useState(true); 

  useEffect(() => {
    setLoading(true);
    axios
      .post(`${process.env.REACT_APP_API}/weddings/get-wedding-by-url`, {friendlyURL})
      .then(response => {
        const { weddingDate, clientName, spouseName } = response.data;
        setWeddingDate(weddingDate);
        setClientName(clientName);
        setSpouse(spouseName);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error retrieving wedding info:', error);
        setLoading(false);
      });
  }, [friendlyURL]);

  if (loading) {
    return (
      <div className="container">
        <div className="loaderContainer">
          <div className="loader"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="preview">
        <div className="header">
          <h1 className="save">SAVE</h1>
          <h2 className="the">the</h2>
          <h1 className="date">DATE</h1>
        </div>

        <div className="names">
          <p>{clientName ? clientName.split(" ")[0] : ""} {clientName && spouse ? "&" : ""}</p>
          <p>{spouse ? spouse.split(" ")[0] : ""}</p>
        </div>

        <img
          src={icon}
          alt="Save the date icon"
          className="icon"
        />

        <p className="weddingDate">{moment(weddingDate).format('DD/MM/YY')}</p>
    

        <p className="invitationText">Invitation to follow</p>
      </div>

      <a href='https://firstdance.app' target='_blank'>
        <p id='poweredBy'>Powered by <span style={{ fontWeight: 'bold'}}>First Dance</span><img src={fdm} style={{height: 10, width: 10, marginLeft: 5}}/></p>
      </a>
    </div>
  );
};

export default SaveTheDate;
